<template lang="pug">
  b-container.content-wrap(fluid)
    b-container.d-flex.justify-content-between(fluid)
      .title
        span.page-title {{$t('user_page.approver_management')}}

    b-row.search-form
      b-col(cols="5")
      b-col.right-btns(cols="7")
        //- b-form-file(accept=".xlsx" size="sm" @change="readFile")
        //- b-btn(size="sm" variant="primary" @click="excel_upload_confirm")
        //-   span 엑셀 업로드
        //- b-btn(size="sm" :disabled="!excelLoaded" @click="downloadExcel")
          span 엑셀 다운로드
        b-btn(size="sm" variant="primary" @click="handlerModifyStep(null)")
          span {{$t('user_page.bulk_update')}}

    b-card.table-card
      b-table(
        ref="table"
        :fields="tableData.fields"
        :items="fetchList"
        :current-page="tableData.pagination.current"
        :per-page="tableData.pagination.limit"
        :empty-text="$t('no-content')"
        tbody-class="lmm-table-body"
        sort-by="name"
        :sort-desc="false"
        show-empty
        responsive
      )
        //- header
        template(v-slot:head(check)="row")
          b-form-checkbox(v-model="allSelected" @input="selectAllRows")

        //- body
        template(v-slot:cell(check)="row")
          b-form-checkbox(v-model="row.item.isSelected" @change="handleCheck(row.item)")
        template(v-slot:cell(user_type)="row")
          span.member-type-icon(v-if="row.item.user_type === 2 || row.item.user_type === 3") S
          span.member-type-icon(v-if="row.item.user_type === 6") A

        template(v-slot:cell(id)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.pk}}") {{row.item.id}}

        template(v-slot:cell(name)="row")
          b-btn(variant="link", :to="{name: 'edit-manager', params: {id: row.item.pk}}") {{row.item.name}}

        template(v-slot:cell(manage_seq)="row")
          span {{ manageSeq(row.item.manage_seq) }}

        template(v-slot:cell(btn)="row")
          b-button.d-inline-flex(size="sm" @click="handlerModifyStep(row.item)") {{$t('change')}}

    //- pagination
    .pagination-wrap
      div
        b-form-select(
          size="sm"
          v-model="tableData.pagination.limit"
          :options="tableData.pagination.perOptions"
        )
      b-pagination(
        size="sm"
        v-model="tableData.pagination.current"
        :total-rows="tableData.pagination.total"
        :per-page="tableData.pagination.limit"
        class="my-0 float-right"
      )
    dialog-approver-step(:show.sync="visibleDialogApproverStep" :selected="selected" @close="visibleDialogApproverStep = false" @complete="completeModify")
</template>

<script>
import DialogApproverStep from "../components/dialogApproverStep.vue"
import { ApprovalAPI, GetMgridAPI } from "@/api"
import _ from "lodash"
import { AnalysticAPI } from "../../../api"
import moment from "moment"
import { ApprovalExcelUploadAPI } from "@/api"
import XLSX from "xlsx"

export default {
  components: {
    DialogApproverStep,
  },
  computed: {
    manageSeq() {
      return (value) => {
        if (value === 0) {
          return this.$t('user_page.not_set')
        } else if (value < 9) {
          return `${value}${this.$t('user_page.step')}`
        } else if (value === 9) {
          return this.$t('total')
        }
      }
    },
  },
  data() {
    return {
      //엑셀 다운로드 관련 파라미터
      range: {
        start: new Date().setDate(-1),
        end: new Date(),
        disabledDates: "",
        lang: "",
      },

      excel_upload_json: {},
      excelLink: null,

      excelLoaded: true,
      visibleDialogApproverStep: false,

      allSelected: false,
      checked: [],
      selected: [],

      tableData: {
        fields: [
          {
            key: "check",
            label: "",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: false,
            thStyle: { width: "1%" },
          },
          { key: "user_type", label: this.$t("admin_privileges"), sortable: true, thStyle: { minWidth: "120px" } },
          { key: "id", label: this.$t("ID"), sortable: true, thStyle: { minWidth: "110px" } },
          // { key: "knoxid", label: "Knox ID", sortable: true, thStyle: { minWidth: "110px" } },
          { key: "name", label: this.$t("user"), sortable: true, thStyle: { minWidth: "120px" } },
          { key: "part_name", label: this.$t("department"), sortable: true, thStyle: { minWidth: "120px" } },
          { key: "manage_seq", label: this.$t('user_page.approval_step'), sortable: true, thStyle: { minWidth: "100px" } },
          { key: "btn", label: this.$t('setting'), sortable: false, thStyle: { minWidth: "80px" } },
        ],
        list: [
          {
            pk: 1,
            userPk: 8427,
            name: "IT운영",
            submanager: "홍길동",
            count: 11,
          },
          {
            pk: 2,
            userPk: 8427,
            name: "인사",
            submanager: "최창민",
            count: 8,
          },
        ],
        pagination: {
          by: "id",
          limit: 24,
          offset: 0,
          order: "asc",
          search_mode: "pagination",

          sortDesc: false,
          total: 1,
          current: 1,
          perOptions: [
            { value: 12, text: "12" },
            { value: 24, text: "24" },
            { value: 36, text: "36" },
          ],
        },
      },
    }
  },
  methods: {
    fetchList(ctx) {
      if (!ctx) return
      if (ctx.sortBy === "") return

      ////엑셀 다운로드
      let params = {
        by: "create_time",
        start_date: moment(this.range.start).format("YYYY-MM-DD"),
        end_date: moment(this.range.end).format("YYYY-MM-DD"),
        limit: ctx.perPage,
        offset: ctx.perPage * (ctx.currentPage - 1),
        order: "desc",
        search_mode: "pagination",
        export_id: "neturo_managerTable",
      }
      AnalysticAPI.excel
        .post("", params)
        .then(resp => {
          if (!resp.data.objects.length) {
            const downloadUrl = resp.data.objects.download_url
            const fileName = resp.data.objects.file_name
            if (process.env.VUE_APP_SCI) {
              this.excelLink = `${this.AppState.Path.origin}:8443${downloadUrl}/${fileName}`
            } else {
              this.excelLink = `${this.AppState.Path.origin}${downloadUrl}/${fileName}`
              this.excelLink = `.${downloadUrl}/${fileName}`
            }
            this.excelLoaded = true
          } else {
            this.excelLink = null
            this.excelLoaded = false
          }
        })
        .catch(error => {
          console.log(error)
        })
      ////

      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit

      let params2 = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,
        search_mode: "pagination",
      }

      return ApprovalAPI.approvalLine.get("", { params: params2 }).then(res => {
        this.tableData.pagination.total = res.data.meta.total_count
        this.allSelected = false
        this.tableData.list = res.data.objects

        this.SelectedAPI_data = res.data
        this.SelectedAPI_data.excel_doc_title = this.$t('user_page.approver_management')

        return res.data.objects
      })
    },
    handlerModifyStep(item) {
      if (!item && this.checked.length < 1) {
        this.$bvToast.toast(this.$t('user_page.no_selected_items'), {
          title: "Error",
          variant: "danger",
          solid: true,
        })
        return
      }
      this.selected = _.cloneDeep(this.checked)
      if (item) this.selected = [item]

      this.visibleDialogApproverStep = true
    },
    completeModify() {
      this.checked = []
      this.visibleDialogApproverStep = false
      this.$refs.table.refresh()
    },
    handleCheck(item) {
      if (this.checked.includes(item)) {
        const index = this.checked.findIndex(u => u.pk === item.pk)
        this.checked.splice(index, 1)
      }
      if (item.isSelected) {
        this.checked.push(item)
      }
    },
    selectAllRows() {
      _.each(this.tableData.list, v => {
        v.isSelected = this.allSelected
        this.handleCheck(v)
      })
    },
    async downloadExcel() {
      this.excelLoaded = true
      const params = await this.fetchExcel()
        .then(params => {
          //전송용 임시 폼 엘리먼트 생성
          var form = document.createElement("form")
          form.method = "post"
          form.action = "/download/excel.html" // /download/excel.html을 통해 DownloadExcelFileAPI호출

          // 엑셀 생성에 필요한 필터된 데이터를 폼에 추가
          let jsonData = {...params, language: this.$i18n.locale}
          
          var input = document.createElement("input")
          input.type = "hidden"
          input.name = "jsondata"
          input.value = JSON.stringify(jsonData)
          form.appendChild(input)

          // body에 폼 추가 및 제출 그 후 제거
          document.body.appendChild(form)
          form.target = "_blank"
          form.submit()
          document.body.removeChild(form)

          this.excelLoaded = false
        })
        .catch(err => {
          this.excelLoaded = false
          alert(this.$t('toasts_message.no_data_to_download_excel'))
          return
        })
    },
    async fetchExcel() {
      // if (this.tableData.pagination.total < 1) {
      //   throw new Error("데이터가 없습니다.")
      // }
      let params = {
        by: "create_time",
        start_date: moment(this.range.start).format("YYYY-MM-DD"),
        end_date: moment(this.range.end).format("YYYY-MM-DD"),
        limit: 0,
        offset: 0,
        order: "desc",
        export_id: "neturo_managerTable",
      }

      const list = await ApprovalAPI.approvalLine.get("", { params })
      const excelParams = list.data
      excelParams.excel_doc_title = this.$t('user_page.approver_management')

      //console.log(excelParams.objects)
      const { data } = await GetMgridAPI.get("")
      const excelParams_for_download = {
        api: excelParams.api,
        excel_doc_title: "",
        pagename: "",
        mgrid: data.objects.mgrid,
        objects: this.downloaded_excel_data_form(excelParams.objects),
      }
      excelParams_for_download.pagename = "user_approval"
      excelParams_for_download.excel_doc_title = this.$t('user_page.approver_management')

      return excelParams_for_download
    },
    downloaded_excel_data_form(input) {
      let originalLocale = this.$i18n.locale
      this.$i18n.locale = "ko"
      
      //input = excelParams.objects
      let user_type = {
        "2": this.$t('policy_manager'),
        "3": this.$t('policy_manager'),
        "6": this.$t('mid_manager'),
      }
      let output = []
      for (let index = 0; index < input.length; index++) {
        let obj = {
          [this.$t('admin_privileges')]: user_type[input[index]["user_type"]],
          [this.$t('ID')]: input[index]["id"],
          "Knox ID": input[index]["knoxid"],
          [this.$t('account-manage')]: input[index]["name"],
          [this.$t('department')]: input[index]["part_name"],
          [this.$t('user_page.approval_step')]: this.return_manage_seq(input[index]["manage_seq"]),
        }
        let obj2 = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, this.nullcheck(value)]))
        output.push(obj2)
      }
      this.$i18n.locale = originalLocale
      return output
    },
    nullcheck(input) {
      return input == null ? "-" : input
    },
    Date_time_split(input) {
      let return_array = []
      if (input != "-") {
        let input_array = input.split("T")
        return_array[0] = input_array[0]
        return_array[1] = input_array[1]
          .split(":")
          .slice(0, 2)
          .join(":")
      } else {
        return_array[0] = "-"
        return_array[1] = "-"
      }
      return return_array
    },
    return_manage_seq(value) {
      if (value === 0) {
        return this.$t('user_page.not_set')
      } else if (value < 9) {
        return `${value}${this.$t('user_page.step')}`
      } else if (value === 9) {
        return this.$t('total')
      }
    },
    excel_upload_confirm(evt) {
      //체크용
      alert("uploaded!")

      ApprovalExcelUploadAPI.post("", this.excel_upload_json)
        .then(resp => {
        })
        .catch(e => {
          console.log(e)
        })
    },
    readFile(event) {
      var input = event.target
      var reader = new FileReader()
      reader.onload = e => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: "binary" })
        var tempitemlist
        wb.SheetNames.forEach(function(sheetName) {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 0,
            defval: "",
          })
          var itemList = JSON.stringify(rowObj)
          tempitemlist = JSON.stringify(rowObj) // 공용변수로 넘겨주기 위한 작업
        })
        this.excel_upload_json = tempitemlist //공용변수로 전송
      }
      reader.readAsBinaryString(input.files[0])
    },
  },
}
</script>

<style lang="scss" scoped>
svg {
  color: #ababab;
}
</style>
